export default __webpack_public_path__ + "static/media/cms.6eec1583.png";